import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

const certifications = [
  { id: 'gh300', cat: 'copilot', badge: 'New', title: 'GitHub Copilot Certification - GH-300', rating: '4.7', desc: 'Master AI-assisted development with GitHub Copilot. Hands-on certification prep using real-world scenarios.', price: '\u20b91,999', was: '\u20b93,999', link: '/gh300' },
  { id: 'az900', cat: 'azure', badge: 'Bestseller', title: 'Azure Fundamentals - AZ-900 Certification', rating: '4.8', desc: 'Demonstrate foundational knowledge of cloud concepts and Azure services. Hands-on prep for Microsoft Certified: Azure Fundamentals.', price: '\u20b92,499', was: '\u20b94,999', link: '/cloud-bundle-az900' },
  { id: 'pl900', cat: 'power', badge: 'Popular', title: 'Power Platform Fundamentals - PL-900 Certification', rating: '4.7', desc: 'Master Power Platform with hands-on low-code / no-code solutions. Build real apps from day one.', price: '\u20b92,499', was: '\u20b94,999', link: '/cloud-bundle-pl900' },
  { id: 'dp900', cat: 'data azure', badge: 'Bestseller', title: 'Azure Data Fundamentals - DP-900 Certification', rating: '4.8', desc: 'Master Azure Data Fundamentals with hands-on labs. Build real data solutions from day one.', price: '\u20b92,499', was: '\u20b94,999', link: '/cloud-bundle-dp900' },
];

const filters = [
  { key: 'all', label: 'All' },
  { key: 'copilot', label: 'GitHub Copilot' },
  { key: 'azure', label: 'Azure' },
  { key: 'power', label: 'Power Platform' },
  { key: 'data', label: 'Data' },
];

function HomeCertificationsSection() {
  const [active, setActive] = useState('all');

  const visible = useMemo(() =>
    active === 'all' ? certifications : certifications.filter((c) => c.cat.includes(active)),
    [active]
  );

  return (
    <section className="band bg-white" id="certifications" aria-labelledby="certs-title">
      <div className="wrap">
        <div className="head-block center">
          <p className="eyebrow">Self-Paced</p>
          <h2 className="section-title" id="certs-title" style={{ marginTop: '12px' }}>
            Certification <span className="red">Programs</span>
          </h2>
          <p className="section-sub">Self-paced courses built for quick skill-building and exam readiness. Study at your own pace, get certified, and show employers what you know.</p>
        </div>

        <div className="pills" role="group" aria-label="Filter certifications">
          {filters.map((f) => (
            <button key={f.key} className={`pill${active === f.key ? ' active' : ''}`} onClick={() => setActive(f.key)}>{f.label}</button>
          ))}
        </div>

        <div className="card-grid cols-4">
          {visible.map((c) => (
            <article className="pcard" key={c.id} data-cat={c.cat}>
              <div className="pcard-img ph" aria-hidden="true">[{c.title}]</div>
              <div className="pcard-body">
                <div className="pcard-badges">
                  <span className="badge badge-workshop">Course</span>
                  <span className="badge badge-soft">{c.badge}</span>
                </div>
                <h3>{c.title}</h3>
                  <div className="rating">
                    <span className="s" aria-hidden="true">
                      <svg viewBox="0 0 24 24" width="14" height="14" focusable="false">
                        <path d="M12 3.8 14.6 9l5.7.8-4.1 4 1 5.7L12 16.8 6.8 19.5l1-5.7-4.1-4 5.7-.8z" fill="currentColor" />
                      </svg>
                    </span>
                    {c.rating}
                  </div>
                <p className="desc">{c.desc}</p>
                <div className="pcard-foot">
                  <div className="price">
                    <span className="now">{c.price}</span>
                    <span className="was">{c.was}</span>
                  </div>
                  <Link className="btn btn-red btn-sm" to={c.link}>Enroll Now</Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeCertificationsSection;
